import type { ModalConfig } from 'src/types/Modals';
import { ValidateEmailPromptModalConfig } from './ValidateEmailPromptModalConfig';
import { PromoBasicModalConfig } from './PromoBasicModalConfig';
import { GtcPpModalConfig } from './GtcPpModalConfig';
import { PromoPremiumModalConfig } from './PromoPremiumModalConfig';
import { ExpirationPremiumModalConfig } from './ExpirationPremiumModalConfig';
import { WhatsNewModalConfig } from './WhatsNewModalConfig';
import { HomesWhatsNewModalConfig } from './HomesWhatsNewModalConfig';
import { RatingPromptModalConfig } from './RatingPromptModalConfig';
import { BluetoothScanModalConfig } from './BluetoothScanModalConfig';
import { BlackFridayPhase1Config } from './BlackFridayPhase1Config';
import { BlackFridayPhase2Config } from './BlackFridayPhase2Config';
import { Gen1ReplacementConfig } from './Gen1ReplacementConfig';
import { AppIconModalConfig, resetChristmasIconIfNeeded } from './AppIconModalConfig';
import { XlX2FlashDealModalConfig } from './XlX2FlashDealModalConfig';
import { WallDisplayFlashSale2ModalConfig } from './WallDisplayFlashSale2ModalConfig';
import { SpringDeals2026ModalConfig } from './SpringDeals2026ModalConfig';
import { SmartHomeChallenge2026ModalConfig } from './SmartHomeChallenge2026ModalConfig';
import { ShellyBirthday2026ModalConfig } from './ShellyBirthday2026ModalConfig';

// Configurations for modals can be anything that implements the ModalConfig interface
export const modalsConfig = async (): Promise<ModalConfig[]> => {
	resetChristmasIconIfNeeded();

	return [
		// ValidateEmailPromptModalConfig,
		GtcPpModalConfig(),
		PromoPremiumModalConfig,
		PromoBasicModalConfig,
		await WhatsNewModalConfig(),
		HomesWhatsNewModalConfig(),
		ExpirationPremiumModalConfig(),
		RatingPromptModalConfig(),
		BluetoothScanModalConfig,
		BlackFridayPhase1Config(),
		BlackFridayPhase2Config(),
		// Gen1ReplacementConfig(),
		XlX2FlashDealModalConfig(),
		WallDisplayFlashSale2ModalConfig(),
		// SpringDeals2026ModalConfig(),
		// SmartHomeChallenge2026ModalConfig(),
		// ShellyBirthday2026ModalConfig(),
		AppIconModalConfig,
	];
};
